import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
// servicio
import { FinanzasService } from 'app/finanzas/finanzas.service';

// entidades
import { Empresa, ComprobanteE, Query } from 'app/finanzas/entidades';
import { operacion } from '../movimientos/movimientos.component';

//  modales
import { ConsultaFechaComponent } from 'app/finanzas/modals/consultaFecha/consultaFecha.component';
import { FormComprobanteComponent } from 'app/finanzas/modals/form-comprobante/form-comprobante.component';
import { RelGastos } from 'app/finanzas/modals/relGastos/relGastos.component';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-comprobante',
  templateUrl: './comprobante.component.html',
  styleUrls: ['./comprobante.component.css']
})
export class ComprobanteComponent implements OnInit {

  p: number = 1;  // Variable del paginador

  comprobante: ComprobanteE = new ComprobanteE();

  empresa: Empresa;
  anio: Number;
  mes: Number;
  nombre_empresa: any ;
  mes_mostrar : any;
  id_empresa:any;
  diferenciaCE_MC: any;

  comprobantes: Array<ComprobanteE>; // Array que contiene los comprobantes del mes consultado
  
  constructor( private servicio: FinanzasService, 
              private route: ActivatedRoute, 
              public dialog:MatDialog, 
              public _location: Location   ) { 

                this.route.queryParams.subscribe( ( params )=>{                  
                  this.empresa = params.empresa;
                  this.anio = params.anio;
                  this.mes = params.mes
                })

                this.comprobantes = [];
              }

  ngOnInit() {
      this.servicio.filtroComprobante(this.empresa, this.anio, this.mes)
        .subscribe( (resp : Array<ComprobanteE> )  => {
          this.comprobantes = resp
      })
      this.tablaEmpresas();
      this.mostrar_mes();
      this.diferenciaCE();
  }

  tablaEmpresas(){this.servicio.getEmpresaId(this.empresa)
    .subscribe( (  [resp]:Array<Empresa>  ) => {
      this.nombre_empresa = resp.Empresa
  })}

  private mostrar_mes(){this.servicio.getMeses(this.mes)
    .subscribe( (  [ resp ]: any   ) => {
        this.mes_mostrar = resp.nombre_mes;  
    })
  }

  private diferenciaCE(){
    this.servicio.diferencia1(this.empresa, this.anio, this.mes )
      .subscribe( (  [resp] : Array<operacion>  )  => {
        this.diferenciaCE_MC = resp.resultado
        
    });
  }

  totales() {
    return this.comprobantes.map(ComprobanteE => ComprobanteE.monto)
      .reduce(( acc, value )=> acc + value , 0);
  }

  AbrirModal(): void {
    const dialogRef = this.dialog.open(ConsultaFechaComponent, {
      width: '450px',
      data: {
        
        empresa: this.empresa,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
  
    });
  }

  relacionarGastos(idComprobante):void {
    const dialogRef = this.dialog.open(RelGastos, {
      width:'400px', 
      data:{
        idComprobante, 
        empresa: this.empresa, 
        anio : this.anio, 
        mes : this.mes 

      }
    });

    dialogRef.afterClosed().subscribe( result => {
      
      this.ngOnInit()
    });
  }

  formComprobante(idComprobante): void {
    const dialogRef = this.dialog.open(FormComprobanteComponent, {
      width: '500px',
      data: {
        idComprobante,
        anio: this.anio,
        mes: this.mes,
        empresa: this.empresa,
        comprobantes: this.comprobantes,
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.comprobante = result;
      this.guardar()
    });
  }



  eliminarRegistro( item ){
    Swal.fire({
      title: '¿Esta seguro que desea eliminar este registro?',
      type: 'warning',
      showCancelButton:true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si'

    }).then((result) => {
      
      if (result.value) {
        this.comprobante = item;
        this.comprobante['estado'] = 0;
        this.servicio.borrarBitacoraCE(this.comprobante, item.idComprobante)
          .subscribe( (resp:Query) => {
            if( resp.affectedRows != 0 ){
              Swal.fire(
                'Eliminado',
                'El archivo fue eliminado correctamente',
                'success'
              )}

            this.servicio.filtroComprobante(this.empresa, this.anio, this.mes)
              .subscribe( (resp  :Array<ComprobanteE>)  => {
                this.comprobantes = resp
                this.diferenciaCE()
            })
        })
      }
    })
  }
  
  guardar() { 
    if (this.comprobante['idComprobante'] != undefined){
      this.servicio.updateComprobante(this.comprobante, this.comprobante['idComprobante'])
          .subscribe( (status:Query ) => {
            const affectedRows = status.affectedRows 
            if (affectedRows != 0){
              Swal.fire({
                type:'success', 
                title: 'Registro Actualizado',
              })
            }
            this.servicio.filtroComprobante(this.empresa, this.anio, this.mes)
              .subscribe( (resp  :Array<ComprobanteE>)  => {
                this.comprobantes = resp
                this.diferenciaCE()
            })
          });
    }
    else {
      this.servicio.insertComprobante(this.comprobante)
        .subscribe(  (status:Query)  => {
          const id_insert = status.insertId;

          if(id_insert != 0){
            Swal.fire({
              type:  'success',
              title:  'Regsitro Guardado',
            })
            this.servicio.filtroComprobante(this.empresa, this.anio, this.mes)
              .subscribe( (resp  :Array<ComprobanteE>)  => {
                this.comprobantes = resp;
                this.diferenciaCE()
            })
          }
          else{
            Swal.fire({
              type: 'error',
              title: 'El registro no se pudo guardar'
            })
          }
        });
    }
  }
}
